import React from "react";
import { Modal, Button, OverlayTrigger, Popover } from "react-bootstrap";
import useEvadtsDict from "../../hooks/useEvadtsDict";

const mono = {
  whiteSpace: "pre-wrap",
  fontFamily: "ui-monospace, Menlo, Consolas, monospace",
  overflow: "visible"
};

function HintBadge({ code, getHintByCode }) {
  const [show, setShow] = React.useState(false);

  if (!code) return null;
  const hintHTML = getHintByCode(code);
  if (!hintHTML) return null;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setShow((prev) => !prev);
  };

  const pop = (
    <Popover
      id={`evadts-hint-${code}`}
      className="shadow-sm"
      style={{ maxWidth: 650 }}
    >
      <Popover.Content>
        <div
          className="custom-scroll"
          style={{
            maxHeight: 400,
            overflowY: "auto",
          }}
          dangerouslySetInnerHTML={{ __html: hintHTML }}
        />
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={[]}
      placement="right"
      overlay={pop}
      show={show}
      container={document.body}
    >
      <span
        className="ml-2 text-muted"
        style={{ cursor: "pointer" }}
        role="button"
        tabIndex="0"
        onClick={handleClick}
      >
        <i className="fas fa-info-circle compare-modal-icon" />
      </span>
    </OverlayTrigger>
  );
}

export default function EvadtsCompareResultModal({
  show,
  onHide,
  rows = [],
  headerLeft = null,
  headerRight = null,
}) {
  const fmt = (v) => (typeof v === "string" ? v.replace(/\*/g, ":") : v);
  const { getHintByCode } = useEvadtsDict();

  const loading = !Array.isArray(rows) || rows.length === 0;

  const grouped = React.useMemo(() => {
    return Object.values(
      (rows || []).reduce((acc, r) => {
        if (!acc[r.Sekcja]) {
          acc[r.Sekcja] = {
            Sekcja: r.Sekcja,
            BieżącyEVADTS: r["Bieżący EVADTS"],
            WybranyEVADTS: r["Wybrany EVADTS"],
          };
        }
        return acc;
      }, {})
    );
  }, [rows]);

  return (
    <Modal
      aria-labelledby="evadts-compare-result"
      centered
      show={show}
      onHide={onHide}
      size="xl"
      backdrop="static"
      keyboard={false}
      restoreFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="evadts-compare-result">
          Porównanie danych EVADTS
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex justify-content-between text-center mb-4 custom-scroll">
          <div style={{ width: "48%" }}>
            <div className="fw-bold mb-2" style={{ fontSize: "1.05rem" }}>
              Bieżący stan
            </div>
            {headerLeft ? (
              <>
                <div className="text-muted">{headerLeft.FullName || ""}</div>
                <div className="text-muted">
                  {headerLeft.CreateDateTimeStr || ""}
                </div>
                <div className="text-muted">{headerLeft.UserName || ""}</div>
              </>
            ) : (
              <div className="text-muted small">Brak danych</div>
            )}
          </div>

          <div style={{ width: "48%" }}>
            <div className="fw-bold mb-2" style={{ fontSize: "1.05rem" }}>
              Wybrany stan
            </div>
            {headerRight ? (
              <>
                <div className="text-muted">{headerRight.FullName || ""}</div>
                <div className="text-muted">
                  {headerRight.CreateDateTimeStr || ""}
                </div>
                <div className="text-muted">{headerRight.UserName || ""}</div>
              </>
            ) : (
              <div className="text-muted small">Brak danych</div>
            )}
          </div>
        </div>

        {loading ? (
          <p className="text-muted mb-0">Ładowanie...</p>
        ) : (
          <div
            style={{ maxHeight: "50vh", overflowY: "auto" }}
            className="table-responsive custom-scroll"
          >
            <table className="table table-sm table-bordered align-middle">
              <colgroup>
                <col style={{ width: "28%" }} />
                <col style={{ width: "36%" }} />
                <col style={{ width: "36%" }} />
              </colgroup>
              <thead className="table-light">
                <tr className="pe-none">
                  <th>Sekcja</th>
                  <th>Bieżący EVADTS</th>
                  <th>Wybrany EVADTS</th>
                </tr>
              </thead>
              <tbody>
                {grouped.map((g, i) => (
                  <tr key={i}>
                    <td>
                    <div
                      className="d-flex align-items-center"
                    >
                      <span
                        className="font-weight-semibold"
                        style={{
                          display: "inline-block",
                          width: "42px"
                        }}
                      >
                        {fmt(g.Sekcja)}
                      </span>

                      <HintBadge
                        code={g.Sekcja}
                        getHintByCode={getHintByCode}
                      />
                    </div>
                    </td>
                    <td style={mono}>{fmt(g.BieżącyEVADTS)}</td>
                    <td style={mono}>{fmt(g.WybranyEVADTS)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
}